import { useState } from "react";
import { Loader2, StickyNote } from "lucide-react";

export function LeadNotes({ lead, onSave, testid }) {
  const [open, setOpen] = useState(false);
  const [draft, setDraft] = useState(lead.notes || "");
  const [saving, setSaving] = useState(false);
  const dirty = draft.trim() !== (lead.notes || "");

  const save = async () => {
    setSaving(true);
    try {
      await onSave(lead.id, draft.trim());
      setOpen(false);
    } finally {
      setSaving(false);
    }
  };

  if (!open) {
    return (
      <button
        type="button"
        onClick={() => setOpen(true)}
        data-testid={`${testid}-toggle`}
        className={`inline-flex max-w-[260px] items-start gap-2 text-left text-xs transition-colors hover:text-ink ${lead.notes ? "text-slate-600" : "text-slate-400"}`}
      >
        <StickyNote className="mt-0.5 h-3.5 w-3.5 shrink-0 text-neon/80" />
        <span className="line-clamp-2" data-testid={`${testid}-preview`}>{lead.notes || "Add note"}</span>
      </button>
    );
  }

  return (
    <div className="w-[260px] space-y-2" data-testid={`${testid}-editor`}>
      <textarea
        autoFocus
        rows={3}
        value={draft}
        onChange={(e) => setDraft(e.target.value)}
        placeholder="Private follow-up note…"
        data-testid={`${testid}-input`}
        className="w-full resize-none rounded-lg border border-slate-300 bg-white px-3 py-2 text-xs text-ink placeholder:text-slate-400 focus:border-neon/60 focus:outline-none focus:ring-1 focus:ring-neon/40"
      />
      <div className="flex gap-2">
        <button
          type="button"
          onClick={save}
          disabled={saving || !dirty}
          data-testid={`${testid}-save`}
          className="inline-flex items-center gap-1.5 rounded-full bg-ink px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-white transition-opacity disabled:opacity-40"
        >
          {saving ? <Loader2 className="h-3 w-3 animate-spin" /> : "Save"}
        </button>
        <button
          type="button"
          onClick={() => { setDraft(lead.notes || ""); setOpen(false); }}
          data-testid={`${testid}-cancel`}
          className="rounded-full border hairline px-3.5 py-1.5 font-mono text-[10px] uppercase tracking-[0.18em] text-slate-500 hover:text-ink"
        >
          Cancel
        </button>
      </div>
    </div>
  );
}
